module.exports = __webpack_public_path__ + "static/media/folders.1ae84438.svg";